import ContentItems from "../ContentItems.component";
import { useTemplateController } from "../Field/FieldContext";
import { ContentItem, FieldContentItem } from "../types";
import {
  useReadFieldFromCache,
  useTemplateStoreFromContext,
} from "../Context/hooks";
import { useShallow } from "zustand/react/shallow";

export default function ConditionalDisplaySection({
  content,
  conditionalElement,
}: {
  content: ContentItem[];
  conditionalElement: FieldContentItem;
}) {
  const { editMode } = useTemplateStoreFromContext()(
    useShallow(state => ({
      editMode: state.editMode,
    }))
  );

  const readFieldFromCache = useReadFieldFromCache();

  const conditionalFieldKey = conditionalElement.key;

  const fieldController = editMode
    ? useTemplateController({ name: conditionalFieldKey }).field
    : null;

  // Both branches yield the field ENVELOPE, so `.value` is the answer in each:
  // in edit mode the controller is bound to the envelope node (a field input's
  // own RHF name is `${templateKey}.value`, see InputFieldBase), and the cache
  // read returns the stored FieldValue.
  const conditionalField = editMode
    ? fieldController?.value
    : readFieldFromCache(conditionalFieldKey)?.field;

  // The gate question always renders; the dependent questions appear only once
  // it is answered truthy. An UNANSWERED gate collapses too — previously only an
  // explicit "No" did, so the follow-ups were visible before the question they
  // depend on had been answered.
  // Prefer the gate's own item from `content` (it may carry authoring overrides
  // such as question_text) and fall back to `conditionalElement`, so a template
  // that names a gate it doesn't also list can't render an empty, unanswerable
  // section.
  const gateItem =
    content.find(
      item => item.type === "field" && item.key === conditionalFieldKey
    ) ?? conditionalElement;

  return (
    <div>
      <div>
        <ContentItems content={conditionalField?.value ? content : [gateItem]} />
      </div>
    </div>
  );
}
